import axios from 'axios';

/** @param {string} section @param {number|undefined} lastSeenWsLogId */
export async function personalHubWsLastSeen(section, lastSeenWsLogId) {
  const body =
    typeof lastSeenWsLogId === 'undefined'
      ? { section }
      : { section, lastSeenWsLogId };

  const { data } = await axios.post(
    '/api/user/private-dashboard/personal-hub/ws-last-seen',
    body,
    { withCredentials: true }
  );
  return data;
}

/** @param {string} section */
export async function getPersonalHubWsDiff(section) {
  const { data } = await axios.post(
    '/api/user/private-dashboard/personal-hub/ws-diff',
    { section },
    { withCredentials: true }
  );
  return data;
}
